import { useAuth } from './useAuth';
import type { PermissionAction } from '../types';

export function usePermission(
  resource: string,
  action: PermissionAction
): boolean {
  const { hasPermission } = useAuth();
  return hasPermission(resource, action);
}
